import languages from "../data/i18n/languages.json";

export function getLanguages() {
  return languages;
}
